exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".iti--separate-dial-code .iti__flag-container[data-v-352b89df]{left:0;right:auto;direction:ltr}.fetchingIcon[data-v-352b89df],.mobileDoesNotExistIcon[data-v-352b89df],.mobileExistsIcon[data-v-352b89df]{float:right;margin-right:10px;margin-top:-27px;position:relative;z-index:2;cursor:default}.mobileInvalid[data-v-352b89df]{color:red;margin-top:5px}.mobileExistsIcon[data-v-352b89df]{color:red}.mobileExistsText[data-v-352b89df]{color:red;margin-top:5px}.mobileDoesNotExistIcon[data-v-352b89df]{color:green}", ""]);

// exports
